import { Value } from '@philips-internal/oswald-ui-core';
import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { HttpResponse } from '@philips-internal/oswald-ui-core/lib/services/http-service';
import { FragmentNames, PublicSchedulingActionsAliases } from '../../codegen';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import { showToastNotificationError, showToastNotificationSuccess } from '../../utils/toast-notification-utils';
import BaseController from '../BaseController';

interface PublicAppointmentParams extends Record<string, Value> {
  token: string;
  type: PublicSchedulingActionsType;
}

enum PublicSchedulingActionsType {
  CONFIRM = 'C',
  CANCEL = 'A',
}

@Controller({ fragment: FragmentNames.PUBLIC_SCHEDULING_ACTIONS })
export default class MyChartSendingDocumentsController extends BaseController {

  @OnMount(PublicSchedulingActionsAliases.LAYOUT_PUBLIC_SCHEDULING_ACTIONS)
  handleLayoutLoading(): void {
    const params = this.historyService.getCurrentRouteParams() as PublicAppointmentParams;

    HttpService
      .put(APPLICATION_ENDPOINTS.PUBLIC_UPDATE_APPOINTMENT_STATUS, params)
      .then(response => this.handleUpdateAppointmentSuccess(response, params.type))
      .catch(() => this.handleUpdateAppointmentFailure());
  }

  private handleUpdateAppointmentSuccess({ status }: HttpResponse<unknown>, type: PublicSchedulingActionsType): void {
    if (status === 200 || status === 204) {
      this.historyService.push(APPLICATION_ROUTES.LOGIN);

      switch (type) {
        case PublicSchedulingActionsType.CONFIRM:
          showToastNotificationSuccess('patient.message.appointment-confirm-success');
          break;
        case PublicSchedulingActionsType.CANCEL:
          showToastNotificationSuccess('patient.message.appointment-cancel-success');
          break;
        default:
          break;
      }
    }
  }

  private handleUpdateAppointmentFailure(): void {
    this.historyService.push(APPLICATION_ROUTES.LOGIN);
    showToastNotificationError('patient.link.expired.message', undefined, undefined, 'patient.link.expired');
  }

}
